import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';
import { Link } from '@stackflow/link';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    giftItem: GiftItemRow;
}

function GiftFooter({ giftItem }:Props) {
    const { salePrice, id } = giftItem;
    const [quantity, setQuantity] = useState<number>(1);
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();
    return (
        <Column spacing={3}>
            <Row fullWidth justify='space-between'>
                <Stepper value={quantity}
                    size='lg'
                    min={1}
                    max={20}
                    increase={() => setQuantity(quantity + 1)}
                    decrease={() => setQuantity(quantity - 1)} />
                <Text size='display' fontWeight='bold'>
                    {(salePrice * quantity).toLocaleString()}{priceUnit}
                </Text>
            </Row>
            <Link activityName='GiftOrderActivity'
                style={{ width: '100%' }}
                activityParams={{
                    giftItemId: id,
                    qty: quantity,
                    type: giftItem.giftItemType,
                }}>
                <Button fullWidth>
                    {t('giftItem.sendGift')}
                </Button>
            </Link>
        </Column>
    );
}

export default GiftFooter;
